import { Geometry, Point, LineString, Polygon } from 'ol/geom';

export function isValidGeometry(
  geometry: Geometry | null | undefined,
  maxPoints?: number | undefined
): { isValid: boolean; reason: string } {
  if (!geometry) {
    return { isValid: false, reason: 'No shape drawn.' };
  }

  let coordinates: number[] | number[][];
  let isValid: boolean;
  let reason = '';

  switch (geometry.getType()) {
    case 'Point':
      coordinates = (geometry as Point).getCoordinates();
      isValid = true; // A Point is always valid
      reason = '';
      break;
    case 'LineString':
      coordinates = (geometry as LineString).getCoordinates();

      if (maxPoints) {
        isValid = coordinates.length >= 2 && coordinates.length <= maxPoints;
        reason = isValid
          ? ''
          : coordinates.length < 2
          ? 'A line needs at least 2 points.'
          : `This line must have at maximum ${maxPoints} points.`;
      } else {
        isValid = coordinates.length >= 2; // A LineString needs at least 2 points
        reason = isValid ? '' : 'A line needs at least 2 points.';
      }

      break;
    case 'Polygon':
      coordinates = (geometry as Polygon).getCoordinates()[0];
      isValid =
        coordinates.length >= 4 && // A Polygon needs at least 4 points (first and last point should be the same)
        coordinates[0][0] === coordinates[coordinates.length - 1][0] &&
        coordinates[0][1] === coordinates[coordinates.length - 1][1];
      reason = isValid
        ? ''
        : coordinates.length < 4
        ? 'A polygon needs at least 4 points, including the closing point.'
        : 'The first and last points of a polygon must be the same.';
      break;
    case 'Circle':
      isValid = true; // A Circle is considered valid if it exists
      reason = '';
      break;
    default:
      isValid = false;
      reason = 'Unknown geometry type.';
  }

  return { isValid, reason };
}
